/*
|--------------------------------------------------------------------------
| Utilities: Lazy Images
|--------------------------------------------------------------------------
*/
/**
 * Lazy load Images
 * @namespace
 */
__gh__webApp.utilities.lazyImages = {
	"init": function(){
		this.loadAllImages();
	},
	"loadAllImages": function(){
		try{
			$(".image, .parallax-background").unveil({'offset':1500});
		}catch(e){}
	}
};